module.exports = __webpack_public_path__ + "static/media/Canon-70-200mm.286cd494.jpg";